import { render, staticRenderFns } from "./LL_Link.vue?vue&type=template&id=9b206286&scoped=true&"
import script from "./LL_Link.vue?vue&type=script&lang=js&"
export * from "./LL_Link.vue?vue&type=script&lang=js&"
import style0 from "./LL_Link.vue?vue&type=style&index=0&id=9b206286&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b206286",
  null
  
)

export default component.exports